// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2QVj-","header":"PatientBlock_header__1gkxI","label":"PatientBlock_label__3w8uU","option":"PatientBlock_option__f6dT8"};